import {getId} from "@acng/frontend-bounty";

import {REGISTRY_ELEMENT} from "../resource.js";
import {findOrCreate} from "../../service/find-or-create.js";

export class ResourceUtility {
  /**
   * @param {HTMLTemplateElement | ResourceUtility} element
   * @param {string[]} path
   */
  constructor(element, ...path) {
    /**
     * @internal
     * @type {import("./namespace.js").ResourceElement}
     */
    this[REGISTRY_ELEMENT] = findOrCreate(
      element instanceof ResourceUtility ? element[REGISTRY_ELEMENT] : element,
      ...path
    );
  }

  get name() {
    return getId(this[REGISTRY_ELEMENT]);
  }
}
